enum FormSectionId {
  GOUVERNANCE = 'gov',
  PRESERVATION = 'pres',
  MULTIFONCTIONNALITE = 'multi',
}

export default FormSectionId;
